import { z } from "zod";
const InterviewSectionType = {
  Questions: "questions",
  RolePlay: "role-play",
  /** Voice knowledge test. */
  KnowledgeTest: "knowledge-test",
  /** Chat quiz (short knowledge test). */
  ChatQuiz: "chat-quiz"
};
const allInterviewSectionTypes = [
  InterviewSectionType.Questions,
  InterviewSectionType.RolePlay,
  InterviewSectionType.KnowledgeTest,
  InterviewSectionType.ChatQuiz
];
const interviewSectionTypeSchema = z.enum(allInterviewSectionTypes);
const voiceInterviewSectionTypes = [
  InterviewSectionType.Questions,
  InterviewSectionType.RolePlay,
  InterviewSectionType.KnowledgeTest
];
const voiceInterviewSectionTypeSchema = z.enum(voiceInterviewSectionTypes);
function checkIsVoiceInterviewSectionType(type) {
  return voiceInterviewSectionTypeSchema.safeParse(type).success;
}
export {
  InterviewSectionType,
  allInterviewSectionTypes,
  checkIsVoiceInterviewSectionType,
  interviewSectionTypeSchema,
  voiceInterviewSectionTypes
};
//# sourceMappingURL=types.js.map
